'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Helpers = exports.ScrollElement = exports.ScrollLink = exports.animateScroll = exports.scrollSpy = exports.Events = exports.scroller = exports.Element = exports.Button = exports.Link = undefined;
var _Link = require('./components/Link.js');
var _Link2 = _interopRequireDefault(_Link);
var _Button = require('./components/Button.js');
var _Button2 = _interopRequireDefault(_Button);
var _Element = require('./components/Element.js');
var _Element2 = _interopRequireDefault(_Element);
var _scroller = require('./mixins/scroller.js');
var _scroller2 = _interopRequireDefault(_scroller);
var _scrollEvents = require('./mixins/scroll-events.js');
var _scrollEvents2 = _interopRequireDefault(_scrollEvents);
var _scrollSpy = require('./mixins/scroll-spy.js');
var _scrollSpy2 = _interopRequireDefault(_scrollSpy);
var _animateScroll = require('./mixins/animate-scroll.js');
var _animateScroll2 = _interopRequireDefault(_animateScroll);
var _scrollLink = require('./mixins/scroll-link.js');
var _scrollLink2 = _interopRequireDefault(_scrollLink);
var _scrollElement = require('./mixins/scroll-element.js');
var _scrollElement2 = _interopRequireDefault(_scrollElement);
var _Helpers = require('./mixins/Helpers.js');
var _Helpers2 = _interopRequireDefault(_Helpers);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
exports.Link = _Link2["default"];
exports.Button = _Button2["default"];
exports.Element = _Element2["default"];
exports.scroller = _scroller2["default"];
exports.Events = _scrollEvents2["default"];
exports.scrollSpy = _scrollSpy2["default"];
exports.animateScroll = _animateScroll2["default"];
exports.ScrollLink = _scrollLink2["default"];
exports.ScrollElement = _scrollElement2["default"];
exports.Helpers = _Helpers2["default"];
exports["default"] = {
  Link: _Link2["default"],
  Button: _Button2["default"],
  Element: _Element2["default"],
  scroller: _scroller2["default"],
  Events: _scrollEvents2["default"],
  scrollSpy: _scrollSpy2["default"],
  animateScroll: _animateScroll2["default"],
  ScrollLink: _scrollLink2["default"],
  ScrollElement: _scrollElement2["default"],
  Helpers: _Helpers2["default"]
};
void function register() {
  /* react-hot-loader/webpack */var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;
  if (!reactHotLoader) {
    return;
  } /* eslint-disable camelcase, no-undef */
  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports; /* eslint-enable camelcase, no-undef */
  if (!webpackExports) {
    return;
  }
  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/opt/atlassian/pipelines/agent/build/node_modules/react-scroll/modules/index.js");
    return;
  } /* eslint-disable no-restricted-syntax */
  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }
    var namedExport = void 0;
    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }
    reactHotLoader.register(namedExport, key, "/opt/atlassian/pipelines/agent/build/node_modules/react-scroll/modules/index.js");
  }
}();